export const frontmatter = {
    "draft": false,
    "title": "Ticketing system",
    "sidebar_group": "reference",
    "sidebar_label": "Ticketing system",
    "sidebar_order": 3
}

export const toc = []